/**
 * @fileoverview JavaScript glue code.
 * @license Apache-2.0
 */

import "../../../std/portable/index";
import "../binaryen";
import "./float";
import "./i64";
import "./collections";
